// extracted by mini-css-extract-plugin
module.exports = {"removedList":"ChangeEffectiveDateDialog_removedList__2vnUj","removedTable":"ChangeEffectiveDateDialog_removedTable__3z0Sg"};